export default __webpack_public_path__ + "static/media/student loan.9b01b850.png";